import {User} from './user.model';
import {environment} from '../../environments/environment';

export class NavMenuItem {
  title: string;
  link?: string;
  absolute?: boolean;
  handler?: () => void;

  public static getForUser(): any {
    if (User.guest()) {
      return [
        {title: 'Login', link: '/login'},
      ];
    }
    const shared = [
      {
        title: 'Logout',
        handler: () => {
          User.logout();
        }
      }
    ];
    switch (User.getFromLS().role) {
      default:
        return [
          {title: 'Sheduler', link: '/events'},
          {title: 'Camera List', link: '/cameras'},
          {title: 'Config', link: '/config'},
          ...shared
        ];
    }
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/models/nav-menu-item.model.ts